import cx from 'classnames';
import { Component, h, VNode } from 'preact';

import PartyPill from './PartyPill';

interface Props {
  ballotName: string;
  candidateId: string;
  isIncumbent: boolean;
  isWinner: boolean;
  party: string;
}

class CandidateRow extends Component<Props> {
  static Header: VNode;
  static countyHeader: VNode;
  static columnCount: number;

  render() {
    const {
      ballotName,
      isIncumbent,
      isViewable,
      party,
    } = this.props;

    let rowClass = cx('candidate', 'contest__candidate-row');

    if (!isViewable) {
      rowClass += ' race__candidate-row--hidden';
    }

    const IsAsterisk =
      ballotName == 'Lloyd Doggett' ||
      ballotName == 'Vicente Gonzalez' ||
      ballotName == 'Mayes Middleton' ||
      ballotName == 'Tan Parker' ||
      ballotName == 'Trent Ashby' ||
      ballotName == 'James Talarico'
        ? true
        : false;


    return (
      <tr class={rowClass}>
        <td class="candidate__cell candidate__party">
         <PartyPill party={party} />
        </td>
        <th class="candidate__cell candidate__name">
          {ballotName}
          {IsAsterisk && <span class="asterisk_out" title="An asterisk next to this candidate">*</span>}{' '}
          {isIncumbent && (
            <span class="pill pill--basic" title="Currently holds this seat">
              Incumbent
            </span>
          )}
        </th>
      </tr>
    );
  }
}

CandidateRow.defaultProps = {
  contestIsCalled: false,
  isViewable: true,
};

CandidateRow.Header = (
  <thead>
    <tr>
      <th class="contest__candidate-header" colSpan={2}>
        Candidates
      </th>
    </tr>
  </thead>
);

CandidateRow.countyHeader = (
  <thead>
    <tr>
      <th class="contest__candidate-header" colSpan={2}>
        Candidates
      </th>
    </tr>
  </thead>
);

CandidateRow.columnCount = 2;

export default CandidateRow;
